import { DashboardMenu } from "../../data/menu";
import BreadCrump from "../tools/breadcrump";
import DashboardButton from "../Setting/dashboardButton";
import { useTranslation } from 'react-i18next';

export default function IndexMarketplace() {
    const { t } = useTranslation();

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Marketplace Management',
            url: null
        },
    ];
    return (
        <>
            <div className="text-left  bg-white  p-3 m-4 directions  h-[100vh] mb-5 ">
                <BreadCrump data={breadcrump}></BreadCrump>
                <DashboardButton item="Marketplace Management" DashboardMenu={DashboardMenu}></DashboardButton>
            </div>
        </>
    );
}
